export enum PaymentsEnum {
  FetchCheckoutSessionIdStart = 'FetchCheckoutSessionIdStart',
  FetchCheckoutSessionIdSuccess = 'FetchCheckoutSessionIdSuccess',
  FetchCheckoutSessionIdFail = 'FetchCheckoutSessionIdFail',

  FetchUserTransactionsStart = 'FetchUserTransactionsStart',
  FetchUserTransactionsSuccess = 'FetchUserTransactionsSuccess',
  FetchUserTransactionsFail = 'FetchUserTransactionsFail',

  CancelUserSubscriptionStart = 'CancelUserSubscriptionStart',
  CancelUserSubscriptionSuccess = 'CancelUserSubscriptionSuccess',
  CancelUserSubscriptionFail = 'CancelUserSubscriptionFail',
}
